const Constants = {
  JIRA_HELPDESK_URL: 'https://intowow.atlassian.net/servicedesk/customer/portal/1',
  SUPPORT_EMAIL: 'support@intowow.atlassian.net',
  FAQ_URL: 'https://intowow.atlassian.net/wiki/spaces/IYBW/pages/648675422/Q+A',
  GETTING_STARTED: 'https://intowow.atlassian.net/wiki/spaces/IYBW/pages/647135394/YieldBooster+on-line+sign+up+tutorial',
  problems: {
    KEY_VALUES_NOT_REPORTABLE: {
      name: 'KEY_VALUES_NOT_REPORTABLE',
    },
    UNLINKED_ADSENSE_ACCOUNT: {
      name: 'UNLINKED_ADSENSE_ACCOUNT',
    },
    UNLINKED_ADX_ACCOUNT: {
      name: 'UNLINKED_ADX_ACCOUNT',
    },
    NORMAL: {
      name: 'NORMAL',
    },
    NO_YIELD_SET: {
      name: 'NO_YIELD_SET',
    },
    NO_AD_UNIT: {
      name: 'NO_AD_UNIT',
    },
    UNAUTHORIZED: {
      name: 'UNAUTHORIZED'
    },
    UNAUTHORIZED_NETWORK: {
      name: 'UNAUTHORIZED_NETWORK',
    },
    UNAUTHORIZED_ADSENSE: {
      name: 'UNAUTHORIZED_ADSENSE',
    },
    UNAUTHORIZED_ADX: {
      name: 'UNAUTHORIZED_ADX',
    },
    INVALID: {
      name: 'INVALID',
    },
    MISSING_OPTIMIZATION_ADSENSE_ADUNIT: {
      name: 'MISSING_OPTIMIZATION_ADSENSE_ADUNIT',
    },
    MISSING_GAM_BENCHMARK_ORDER: {
      name: 'MISSING_GAM_BENCHMARK_ORDER',
    },
    NO_AVAILABLE_ACCESSIBLE_ORDERS: {
      name: 'NO_AVAILABLE_ACCESSIBLE_ORDERS',
    },
    NOT_ENOUGH_PERMISSION: {
      name: 'NOT_ENOUGH_PERMISSION',
    },
    ACCESS_DENIED: {
      name: 'ACCESS_DENIED',
    },
    CAPPED: {
      name: 'OPTIMIZATION_CAPPED',
    },
  },
  unitTypes: {
    ABOVE_THE_FOLD: 'ABOVE_THE_FOLD',
    BELOW_THE_FOLD: 'BELOW_THE_FOLD',
    FLOATING: 'FLOATING',
    INTERSTITIAL: 'INTERSTITIAL',
    UNSPECIFIED: 'UNSPECIFIED',
  },
  platformTypes: {
    PC: 'PC',
    MOBILE: 'MOBILE',
    BOTH_PC_AND_MOBILE: 'BOTH_PC_AND_MOBILE',
    UNSPECIFIED: 'UNSPECIFIED',
  },
  status: {
    RUNNING: 'RUNNING',
    PAUSED: 'PAUSED',
    PROCESSING: 'PROCESSING',
  },
  currencies: {
    TWD: 'NT$',
    USD: '$',
    CAD: 'CA$',
    NZD: 'NZ$',
    AUD: 'A$',
    GBP: '£',
    EUR: '€',
    JPY: '¥',
    CNY: '¥',
  },
  multipliers: {
    THOUSANDS: {
      value: 1000,
    },
    MILLIONS: {
      value: 1000000,
    },
    BILLIONS: {
      value: 1000000000,
    },
    TRILLIONS: {
      value: 1000000000000,
    },
    QUADRILLIONS: {
      value: 1000000000000000,
    },
  },
  accountTypes: {
    AD_MANAGER: {
      id: 0,
      name: 'AD_MANAGER',
    },
    INVOICED_AD_MANAGER: {
      id: 1,
      name: 'INVOICED_AD_MANAGER',
    },
      AD_MANAGER_360: {
      id: 2,
      name: 'AD_MANAGER_360',
    },
  }
};


module.exports = Constants;
